var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.stateUpdateHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StateUpdate")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.importVisible = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Import")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "250313",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "680px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Warehouse2"),
                            required: ""
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_AirportCargoTerminal,
                              no: "airportCargoTerminalUuid",
                              filterable: "",
                              "method-params": {
                                dataType: 1,
                                deletionFlag: false,
                                agencyWarehouse: false
                              },
                              "default-value":
                                _vm.editDialog.form.airportCargoTerminalUuid,
                              "options-width": "200px"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.airportCargoTerminalUuid =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_LocationType"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                no: "locationType"
                              },
                              model: {
                                value: _vm.editDialog.form.locationType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "locationType",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.locationType"
                              }
                            },
                            _vm._l(_vm.LOCATION_TYPE_LIST, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_LocationCode"),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "locationCode" },
                            model: {
                              value: _vm.editDialog.form.locationCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "locationCode",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.locationCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_LocationStatus"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                no: "locationStatus",
                                disabled: ""
                              },
                              model: {
                                value: _vm.editDialog.form.locationStatus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "locationStatus",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.locationStatus"
                              }
                            },
                            _vm._l(_vm.LOCATION_STATE_LIST, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_RemarksInfo") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3, no: "remarks" },
                    model: {
                      value: _vm.editDialog.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.editDialog.form, "remarks", $$v)
                      },
                      expression: "editDialog.form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.lookDialog.visible,
            title: _vm.lookDialog.title,
            width: "680px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.lookDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right",
                        disabled: ""
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_ItemsNBR") } },
                        [
                          _c("el-input", {
                            attrs: { no: "quantity" },
                            model: {
                              value: _vm.lookDialog.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "quantity", $$v)
                              },
                              expression: "lookDialog.form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "palletNo" },
                            model: {
                              value: _vm.lookDialog.form.palletNo,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "palletNo", $$v)
                              },
                              expression: "lookDialog.form.palletNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "jobNo" },
                            model: {
                              value: _vm.lookDialog.form.jobNo,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "jobNo", $$v)
                              },
                              expression: "lookDialog.form.jobNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right",
                        disabled: ""
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Weight") } },
                        [
                          _c("el-input", {
                            attrs: { no: "weight" },
                            model: {
                              value: _vm.lookDialog.form.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "weight", $$v)
                              },
                              expression: "lookDialog.form.weight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_MblNo") } },
                        [
                          _c("el-input", {
                            attrs: { no: "mblNo" },
                            model: {
                              value: _vm.lookDialog.form.mblNo,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "mblNo", $$v)
                              },
                              expression: "lookDialog.form.mblNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_WarehouseNo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "warehouseNo" },
                            model: {
                              value: _vm.lookDialog.form.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.lookDialog.form,
                                  "warehouseNo",
                                  $$v
                                )
                              },
                              expression: "lookDialog.form.warehouseNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right",
                        disabled: ""
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                        [
                          _c("el-input", {
                            attrs: { no: "cubAge" },
                            model: {
                              value: _vm.lookDialog.form.cubAge,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "cubAge", $$v)
                              },
                              expression: "lookDialog.form.cubAge"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SeparateNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "hblNo" },
                            model: {
                              value: _vm.lookDialog.form.hblNo,
                              callback: function($$v) {
                                _vm.$set(_vm.lookDialog.form, "hblNo", $$v)
                              },
                              expression: "lookDialog.form.hblNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.lookDialog.visible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("import-dialog", {
        attrs: {
          title: _vm.$t("CargoMsg.Cargo_Import"),
          action: _vm.URL.mdm.importDataUrl,
          visible: _vm.importVisible,
          "folder-name": "mdm",
          "file-name": "StorageLocationImport.xls"
        },
        on: {
          uploadSuccess: _vm.toQuery,
          onClose: function($event) {
            _vm.importVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }